import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OutlinedInput, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { redirect, useLocation, useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { setTokenClientes } from '../../Store/storages/AuthenticationStorage';
import { setBenef } from '../../Store/storages/BeneficiarioStorage';
import { setCodTipoUsrLogado } from '../../Store/storages/CodTipoUsrLogadoStorage';
import { setItemListContratosBeneficiario } from '../../Store/storages/ContratoBeneficiarioStorage';
import ContractSelection from '../../components/ContractSelection';
import LoadingApp from '../../components/LoadingApp';
import ModalFeedBack from '../../components/ModalFeedBack/index';
import { Beneficiario } from '../../interfaces/entities/Beneficiario';
import { BeneficiarioContratoBeneficiario } from '../../interfaces/entities/BeneficiarioContratoBeneficiario';
import { ContratoBeneficiario } from '../../interfaces/entities/ContratoBeneficiario';
import { Error } from '../../interfaces/entities/Error';
import { TokenClientes } from '../../interfaces/entities/TokenClientes';
import { LoginFormProps } from '../../interfaces/props/LoginFormProps';
import { LoginValidation } from '../../interfaces/validation/LoginValidation';
import { getBeneficiario, getContratosBeneficiario, getTokenBenefClientes, tokenBenefExt } from '../../services/LoginService';
import { cpfValidator } from '../../utils/CpfValidator';
import { storeEncryptedItem } from '../../utils/EncryptedItemsManager';
import { onlyNumbers } from '../../utils/OnlyNumbers';
import './styles.css';
import { sxButtonLogin, sxButtonText, sxLabel, sxTypographyTitle, sxValidationMessage } from './sxProps';
import { getCurrentDateTime } from '../../utils/TimeUtils';
import PasswordInput from '../../components/PasswordInput';

const LoginForm: React.FC<LoginFormProps> = ({handlerShowRecuperarSenha }) => {

  const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
  const [iconModal, setIconModal] = useState<'error' | 'success'>('success');
  const [textButtonModal, setTextButtonModal] = useState('');
  const [titleModal, setTitleModal] = useState('');
  const [subTitleModal, setSubTituloModal] = useState('');
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [pass, setPass] = useState<string>('');
  const [idUsrContr, setIdUsrContr] = useState<number>(0);
  const [showModalContract, setShowModalContract] = useState<boolean>(false);
  const [listContratoBeneficiarios, setListContratoBeneficiarios] = useState<Array<BeneficiarioContratoBeneficiario>>([]);
  const [loginError, setLoginError] = useState<boolean>(false);
  const buttonTextContract: string = 'Avançar';
  const navigate = useNavigate();
  const location = useLocation();

  const formik = useFormik({
    initialValues: { userName: '', password: '' },
    validationSchema: LoginValidation,
    onSubmit: (values) => {
      login(values.userName, values.password)
    },
    validateOnChange: false
  })

  const handleModalFeedBack = (): void => {
    setShowModalFeedBack(show => !show);
  }

  const handleModalContract = (): void => {
    setShowModalContract(show => !show);
    setIdUsrContr(0)
  }


  const handleClickRadioButton = (value: number,) => {
    setIdUsrContr(value);
  };


  const handleChangeRadioButton = (value: number, e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.stopPropagation(); // Impede a execução padrão da tecla de seta
    }
    if (e?.key === ' ') {
      e.preventDefault();
      setIdUsrContr(value);
    }
  };

  const storeUserInfos = (listContratosBenef: Array<BeneficiarioContratoBeneficiario>, userName: string, password: string) => {
    setItemListContratosBeneficiario(listContratosBenef);
    storeEncryptedItem('benefKey', userName);
    storeEncryptedItem('benefSecret', password);
  }

  const loginBenefWithJustOneActiveContract = async (lstContratos: BeneficiarioContratoBeneficiario[], password: string) => {
    if (lstContratos.length === 2) {
      const activeContract = lstContratos.find(contrato => contrato.usrContrAtivo);
      const inactiveContract = lstContratos.find(contrato => contrato.usrContrAtivo === false);
      if (activeContract && inactiveContract) {
        await tokenGenerate(activeContract.codAntigoUsr, password)
      }
    }
  }

  const login = async (userName: string, password: string) => {
    try {
      var dataError: Error;
      setShowLoading(true);
      setPass(password);

      /* const usuarioCRM = await validarCRM(userName);
      if (usuarioCRM === 'S') {
        openModalFeedBack('error', 'Voltar', 'Erro ao efetuar login', 'Usuário CRM');
        setShowLoading(false);
        return;
      } */

      if (cpfValidator(userName)) {
        const resultContracts = await getContratosBeneficiario(userName, password);
        if (resultContracts?.status !== 200) {
          dataError = resultContracts?.data;
          openModalFeedBack('error', 'Voltar', 'Erro ao efetuar login', dataError.message);
          setShowLoading(false);
          return;
        }
        var result: ContratoBeneficiario = resultContracts.data;
        if (result.beneficiarios.length > 1) {
          await loginBenefWithJustOneActiveContract(result.beneficiarios, password);
          setListContratoBeneficiarios(result.beneficiarios);
          storeUserInfos(result.beneficiarios, userName, password);
          handleModalContract();
        } else {
          await tokenGenerate(result.beneficiarios[0].codAntigoUsr, password)
        }
      } else {
        await tokenGenerate(userName, password);
      }

      setShowLoading(false);
    } catch (error) {
      console.error({ error });
      openModalFeedBack('error', 'Voltar', 'Erro ao efetuar login', 'Erro: ' + error)
      setShowLoading(false);
    }
  };

  const getAndStoreBenef = async () => {
    const resultBenef = await getBeneficiario();
    if (resultBenef?.status !== 200) {
      var dataError: Error = resultBenef?.data;
      openModalFeedBack('error', 'Voltar', 'Erro ao efetuar login', dataError.message)
    } else {
      var beneficiario: Beneficiario = resultBenef.data.dados;
      setBenef(beneficiario);
      sessionStorage.setItem('lastAccess', getCurrentDateTime());
      navigate('/home');
    }
  }

  const openModalFeedBack = (icon: "error" | "success", textButton: string, title: string, subTitle: string) => {
    setIconModal(icon);
    setTextButtonModal(textButton);
    setTitleModal(title);
    setSubTituloModal(subTitle);
    handleModalFeedBack();
  }

  const tokenGenerate = async (userName: string, password: string) => {
    const resultTokenClientes = await getTokenBenefClientes(userName, password);
    if (resultTokenClientes?.status !== 200) {
      openModalFeedBack('error', 'Voltar', 'Erro ao efetuar login', 'Verifique se os dados foram preenchidos corretamente e tente novamente. Se você ainda não possui um cadastro,  <a target="_blank" href="https://clientes-hml.unimedcampinas.com.br/cadastro">clique aqui</a> e faça agora mesmo. Em caso de dúvidas,  <a target="_blank" href="https://unimedcampinas.virtualinteractions.com.br/pt_BR/avi.html?id=101&channel=1&source=1&target=1&ms=Fri%20Aug%2016%202024%2008:58:16%20GMT-0300%20(Hor%C3%A1rio%20Padr%C3%A3o%20de%20Bras%C3%ADlia)">clique aqui</a> e fale com um de nossos especialistas.')
      setLoginError(true);
    } else {
      var dataTokenClientes: TokenClientes = resultTokenClientes.data;
      setTokenClientes(dataTokenClientes);
      setLoginError(false);
      await getAndStoreBenef();
    }
  }

  const handleSelectContract = async () => {
    setShowLoading(true);
    var selectedContract = listContratoBeneficiarios.find(contratoBeneficiario => contratoBeneficiario.idUsrContr === idUsrContr);
    setCodTipoUsrLogado(selectedContract?.codTipoUsr);
    await tokenGenerate(selectedContract?.codAntigoUsr ? selectedContract?.codAntigoUsr : '', pass);
    setShowLoading(false);
  }

  useEffect(() => {
    autoLogin();
  }, [])

  const autoLogin = async () => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const redirectLink = searchParams.get('redirect');
    if (token) {
      setShowLoading(true);
      var response = await tokenBenefExt(token);
      if (response?.status === 200) {
        var dataTokenClientes: TokenClientes = response.data;
        setTokenClientes(dataTokenClientes);
        await getAndStoreBenef();

        if (redirectLink) {
          navigate(redirectLink);
        }
      }
      setShowLoading(false);
    }

  }

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div className='width-100'>
      <ModalFeedBack
        showModal={showModalFeedBack}
        handleShowModal={handleModalFeedBack}
        icon={iconModal}
        textButton={textButtonModal}
        title={titleModal}
        subTitle={subTitleModal}
        showButtonModal
        handleButtonModal={handleModalFeedBack}
        classNameModal='modal-feedback-error'
      />
      <ContractSelection
        idUsrContr={idUsrContr} handleRadioButton={handleChangeRadioButton}
        showModal={showModalContract} handleShowModal={handleModalContract}
        handleSelectButton={handleSelectContract} listaBeneficiarios={listContratoBeneficiarios}
        buttonText={buttonTextContract}
        handleClickRadioButton={handleClickRadioButton}
      />
      <LoadingApp showLoading={showLoading} />
      <form className='width-100  login-container-end' onSubmit={formik.handleSubmit}>
        <div style={textStyleAccessibility} className='container-login-painel-rigth'>
          <Typography style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Acesso ao Canal</Typography>
          <div className='width-100'>
            <div className='width-100 margin-bottom-20'>
              <Typography style={textStyleAccessibility} sx={sxLabel}>CPF ou Número do cartão</Typography>
              <label htmlFor='userName' aria-label="CPF ou Número do cartão" />
              <OutlinedInput
                id="userName"
                aria-describedby='errUserName'
                fullWidth
                type={'number'}
                value={formik.values.userName}
                placeholder='Exemplos: 123.456.789-00 (CPF) ou 99999999999999999 (cartão) '
                onChange={(event) => { formik.setFieldValue('userName', onlyNumbers(event.target.value)) }}
                name='userName'
                error={!!formik.errors.userName}
                maxRows={1}
                inputProps={{ maxLength: 30 }}
              />
              {(formik.errors.userName || loginError) &&
                <div className='container-validation-message'>
                  <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
                  <Typography id='errUserName' sx={sxValidationMessage} style={textStyleAccessibility} >{formik.errors.userName || 'Verifique se o CPF ou cartão está correto'}</Typography>
                </div>
              }
            </div>
            <label htmlFor='userPassword' aria-label="Senha" />
            <PasswordInput
              id="userPassword"
              label="Senha"
              placeholder="Digite sua senha"
              name="password"
              textError={(!!formik.errors.password || loginError) 
                ? formik.errors.password || 'Verifique se a senha está correta'
                : undefined
              }
              error={!!formik.errors.password || loginError}
              maxLength={30}
              onChange={formik.handleChange}
              fullWidth />
          </div>
          <div className='login-container-action'>
            <Button style={buttonStyleAccessibility} type='submit' variant='contained' sx={sxButtonLogin}>
              <Typography style={buttonTextStyleAccessibility}>Entrar</Typography>
            </Button>
            <Button onClick={handlerShowRecuperarSenha} variant='text' sx={{ ...sxButtonText }}>
              <Typography style={textStyleAccessibility} sx={sxButtonText}>Esqueci minha senha</Typography>
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
